export default createSharedComposable(() => {
  const localePath = useLocalePath();

  const shouldOpenVerification = useState(
    "shouldOpenVerification",
    () => false,
  );

  const openAccountWithVerification = () => {
    shouldOpenVerification.value = true;
    navigateTo(localePath({ path: "/my-account" }));
  };

  return { shouldOpenVerification, openAccountWithVerification };
});
